import Rollbar from 'rollbar'

declare global {
  interface Window {
    Rollbar?: Rollbar
  }
}

// Starts browser-side error reporting when the client token is configured
// (Heroku's Rollbar add-on provisions ROLLBAR_CLIENT_SIDE_ACCESS_TOKEN).
// Exposes the instance as window.Rollbar, which the upload path and the
// GraphQL submission hook use to report failures with context — without this,
// client-side failures leave no trace anywhere.
export const initClientErrorReporting = (): void => {
  const accessToken = process.env.ROLLBAR_CLIENT_SIDE_ACCESS_TOKEN
  if (!accessToken) return

  window.Rollbar = new Rollbar({
    accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: process.env.NODE_ENV || 'production',
      client: {
        javascript: {
          // The build id baked into the page (same meta the stale-tab guard
          // reads) ties each report to the deploy it came from.
          code_version: document.querySelector('meta[name="app-build"]')?.getAttribute('content') ?? undefined,
        },
      },
    },
  })
}
